const mapCustomerRegistrationsResult = ({ data, totalCount }) => {
	const mappedData = data.map((item) => {
		return {
			id: item.id,
			name: item.name,
			phoneNumber: item.phoneNumber,
			item,
		}
	});
	return {
		data: mappedData,
		total: totalCount,
	};
};

export {
	mapCustomerRegistrationsResult
};
